// components/nft/nft-list-item.tsx
import { Edit, Eye, Trash2 } from 'lucide-react';
import React from 'react';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { NFT } from '@/types/nft';

interface NFTListItemProps {
  nft: NFT;
  onEdit: (nft: NFT) => void;
  onDelete: (nft: NFT) => void;
  onView: (nft: NFT) => void;
}

export const NFTListItem: React.FC<NFTListItemProps> = ({
  nft,
  onEdit,
  onDelete,
  onView,
}) => {
  const getStatusColor = (status: NFT['status']) => {
    switch (status) {
      case 'draft':
        return 'bg-gray-500';
      case 'minted':
        return 'bg-blue-500';
      case 'listed':
        return 'bg-green-500';
      case 'sold':
        return 'bg-purple-500';
      default:
        return 'bg-gray-500';
    }
  };

  return (
    <tr className="border-b hover:bg-muted/50">
      <td className="p-4">
        <div className="flex items-center gap-3">
          <img
            src={nft.image}
            alt={nft.name}
            className="w-12 h-12 rounded object-cover"
          />
          <div>
            <div className="font-medium">{nft.name}</div>
            <div className="text-sm text-muted-foreground line-clamp-1">
              {nft.description}
            </div>
          </div>
        </div>
      </td>
      <td className="p-4">{nft.collection}</td>
      <td className="p-4 font-medium">
        {nft.price} {nft.currency}
      </td>
      <td className="p-4">
        <Badge className={getStatusColor(nft.status)}>{nft.status}</Badge>
      </td>
      <td className="p-4 text-sm">{nft.createdAt}</td>
      <td className="p-4">
        <div className="flex gap-2">
          <Button variant="outline" size="sm" onClick={() => onEdit(nft)}>
            <Edit className="w-4 h-4 text-primary" />
          </Button>
          <Button variant="outline" size="sm" onClick={() => onDelete(nft)}>
            <Trash2 className="w-4 h-4 text-red-500" />
          </Button>
          <Button variant="outline" size="sm" onClick={() => onView(nft)}>
            <Eye className="w-4 h-4" />
          </Button>
        </div>
      </td>
    </tr>
  );
};
